/*
 *
 * OrderTreatment actions
 *
 */

import {
  DEFAULT_ACTION,
  GET_PATIENT,
  GET_PATIENT_SUCCESS,
  GET_PATIENT_ERROR,
  GET_INSURERS,
  GET_INSURERS_SUCCESS,
  GET_INSURERS_ERROR,
  GET_DENTISTS,
  GET_DENTISTS_SUCCESS,
  GET_DENTISTS_ERROR,
  CREATE_PRODUCT_PLAN,
  CREATE_PRODUCT_PLAN_SUCCESS,
  CREATE_PRODUCT_PLAN_ERROR,
  UPDATE_PRODUCT_PLAN,
  UPDATE_PRODUCT_PLAN_SUCCESS,
  UPDATE_PRODUCT_PLAN_ERROR,
  GET_ACTIVE_PRODUCT_PLAN,
  GET_ACTIVE_PRODUCT_PLAN_SUCCESS,
  GET_ACTIVE_PRODUCT_PLAN_ERROR,
  SET_PRODUCT_PLAN,
  SET_ACTIVE_ORDER_ID,
  RESET,
  DELETE_ORDER,
  DELETE_ORDER_SUCCESS,
  DELETE_ORDER_ERROR,
  GET_END_TYPE_PRODUCTS,
  GET_END_TYPE_PRODUCTS_SUCCESS,
  GET_END_TYPE_PRODUCTS_ERROR,
} from "./constants";

export function defaultAction() {
  return {
    type: DEFAULT_ACTION,
  };
}

export function getPatient(id) {
  return {
    type: GET_PATIENT,
    id,
  };
}

export function getPatientSuccess(patient) {
  return {
    type: GET_PATIENT_SUCCESS,
    patient,
  };
}

export function getPatientError(error) {
  return {
    type: GET_PATIENT_ERROR,
    error,
  };
}

export function getEndTypeProducts() {
  return {
    type: GET_END_TYPE_PRODUCTS,
  };
}

export function getEndTypeProductsSuccess(data) {
  return {
    type: GET_END_TYPE_PRODUCTS_SUCCESS,
    data,
  };
}

export function getEndTypeProductsError(error) {
  return {
    type: GET_END_TYPE_PRODUCTS_ERROR,
    error,
  };
}

export function getInsurers() {
  return {
    type: GET_INSURERS,
  };
}

export function getInsurersSuccess(insurers) {
  return {
    type: GET_INSURERS_SUCCESS,
    insurers,
  };
}

export function getInsurersError(error) {
  return {
    type: GET_INSURERS_ERROR,
    error,
  };
}

export function getDentists() {
  return {
    type: GET_DENTISTS,
  };
}

export function getDentistsSuccess(dentists) {
  return {
    type: GET_DENTISTS_SUCCESS,
    dentists,
  };
}

export function getDentistsError(error) {
  return {
    type: GET_DENTISTS_ERROR,
    error,
  };
}

export function createProductPlan(productPlan) {
  return {
    type: CREATE_PRODUCT_PLAN,
    productPlan,
  };
}

export function createProductPlanSuccess(productPlan) {
  return {
    type: CREATE_PRODUCT_PLAN_SUCCESS,
    productPlan,
  };
}

export function createProductPlanError(error) {
  return {
    type: CREATE_PRODUCT_PLAN_ERROR,
    error,
  };
}

export function updateProductPlan(productPlan) {
  return {
    type: UPDATE_PRODUCT_PLAN,
    productPlan,
  };
}

export function updateProductPlanSuccess(productPlan) {
  return {
    type: UPDATE_PRODUCT_PLAN_SUCCESS,
    productPlan,
  };
}

export function updateProductPlanError(error) {
  return {
    type: UPDATE_PRODUCT_PLAN_ERROR,
    error,
  };
}

export function getActiveProductPlan(patientId, overrideActiveOrderId) {
  return {
    type: GET_ACTIVE_PRODUCT_PLAN,
    patientId,
    overrideActiveOrderId,
  };
}

export function getActiveProductPlanSuccess(productPlan) {
  return {
    type: GET_ACTIVE_PRODUCT_PLAN_SUCCESS,
    productPlan,
  };
}

export function getActiveProductPlanError(error) {
  return {
    type: GET_ACTIVE_PRODUCT_PLAN_ERROR,
    error,
  };
}

export function setProductPlan(productPlan) {
  return {
    type: SET_PRODUCT_PLAN,
    productPlan,
  };
}

export function setActiveOrderId(orderId) {
  return {
    type: SET_ACTIVE_ORDER_ID,
    orderId,
  };
}

export function reset() {
  return {
    type: RESET,
  };
}

export function deleteOrder(id) {
  return {
    type: DELETE_ORDER,
    id,
  };
}

export function deleteOrderSuccess(data) {
  return {
    type: DELETE_ORDER_SUCCESS,
    data,
  };
}

export function deleteOrderError(error) {
  return {
    type: DELETE_ORDER_ERROR,
    error,
  };
}
